const initialState = {

}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'APP_LOGIN_LOADING':
      return Object.assign({}, state, {
        isLoading: true,
        isLoggedIn: false,
        error: null,
      })

    case 'APP_LOGIN_ERROR':
      return Object.assign({}, state, {
        isLoading: false,
        isLoggedIn: false,
        error: action.payload,
      })

    case 'APP_LOGIN_SUCCESS':
      if (action.payload.status) return state

      return Object.assign({}, state, {
        isLoading: false,
        isLoggedIn: true,
        user: action.payload.user,
        endtest: action.payload.endtest,
      })

    case 'APP_ENDTEST_PROGRESS':
      return Object.assign({}, state, {
        endtest: action.payload,
      })

    default:
      return state
  }
}
